<template>
	<div id="app" class="app-component" :class="[`app-${$route.name}`]">
		<keep-alive :include="cachedViews">
			<router-view />
		</keep-alive>
		<Tool class="tool-wrapper"></Tool>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Tool from '@/layout/Tool/Tool.vue';
export default {
	name: 'App',
	components: {
		Tool
	},
	data() {
		return {
			// cachedViews: [
			// 	// 默认缓存的组件
			// 	'home',
			// 	'information'
			// ],
			isRouterAlive: true
		};
	},
	computed: {
		...mapState(['cachedViews'])
	},
	mounted() {
		// this.$store.dispatch('addView', 'home')
		// 返回顶部功能
		let appEl = document.getElementById('app');
		this.$bus.$on('backTop', (data = {}) => {
			appEl.scrollIntoView(data);
		});
	}
};
</script>

<style lang="scss">
// 公共样式
@import '/src/common/common.scss';
// 动效样式
@import '/src/common/animation.scss';
// element-ui自定义样式
@import '/src/common/element-ui.scss';
</style>
